// import { createContext, useContext, useEffect, useState, useCallback } from 'react'

// const ThemeContext = createContext(null)

// export function ThemeProvider({ children }) {
//   const [theme, setTheme] = useState(() => {
//     const saved = localStorage.getItem('nx-theme')
//     if (saved) return saved
//     return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
//   })

//   useEffect(() => {
//     document.documentElement.setAttribute('data-theme', theme)
//     localStorage.setItem('nx-theme', theme)
//     // Also set Bootstrap's data-bs-theme for Bootstrap components
//     document.documentElement.setAttribute('data-bs-theme', theme)
//   }, [theme])

//   const toggle = useCallback(() => {
//     setTheme(t => (t === 'light' ? 'dark' : 'light'))
//   }, [])

//   return (
//     <ThemeContext.Provider value={{ theme, toggle, isDark: theme === 'dark' }}>
//       {children}
//     </ThemeContext.Provider>
//   )
// }

// export const useTheme = () => {
//   const ctx = useContext(ThemeContext)
//   if (!ctx) throw new Error('useTheme must be used within ThemeProvider')
//   return ctx
// }


import { createContext, useContext, useEffect, useState, useCallback } from 'react'

const ThemeContext = createContext(null)
const STORAGE_KEY = 'nx-theme'

const getPreferredTheme = () => {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'light' || saved === 'dark') return saved
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'light' : 'light'
}

const applyTheme = (theme) => {
  const root = document.documentElement
  root.setAttribute('data-theme', theme)
  // Also set Bootstrap's data-bs-theme for Bootstrap components
  root.setAttribute('data-bs-theme', theme)
}

export function ThemeProvider({ children }) {
  // Must match the prerendered HTML ('light'); the real theme is resolved after mount.
  const [theme, setTheme] = useState('light')

  useEffect(() => {
    const preferred = getPreferredTheme()
    applyTheme(preferred)
    setTheme(preferred)
  }, [])

  const toggle = useCallback(() => {
    setTheme((current) => {
      const next = current === 'light' ? 'dark' : 'light'
      applyTheme(next)
      localStorage.setItem(STORAGE_KEY, next)
      return next
    })
  }, [])

  return (
    <ThemeContext.Provider value={{ theme, toggle, isDark: theme === 'dark' }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider')
  return ctx
}